export default __webpack_public_path__ + "img/f81b04e5c7ce604d128578b52605f8e8.svg";